/** @format */

import React, { useState } from "react";
import Profile from "images/3MTT/profile.png";
import { capitalize } from "utils/strings";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios_instance from "store/constant/axiosInstance";
import { extractErrorMessage } from "utils/strings";
import CircularProgress from "component/CircularProgress";

const ProfileHeader = ({ profileInfo, refetch, isFetching }) => {
  const [showUploadModal, setShowUploadModal] = useState(false);

  const UploadModal = ({ showUploadModal, setShowUploadModal, refetch }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const formik = useFormik({
      initialValues: {
        file: null,
      },
      onSubmit: handleSubmit,
      validationSchema: validationSchema,
    });

    async function handleSubmit(values) {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", values.file);
      axios_instance
        .post("account/profile/upload-profile-photo", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((data) => {
          toast.success(data?.data?.message);
          refetch();
          setShowUploadModal(false);
          formik.resetForm();
          setLoading(false);
        })
        .catch((error) => {
          const formattedError = extractErrorMessage(error?.response);
          toast.error(formattedError);
          setLoading(false);
        });
    }

    function handleFileChange(event) {
      const file = event.target.files[0];
      const allowedFileTypes = ["image/jpeg", "image/png"];
      const maxFileSize = 2 * 1024 * 1024;

      if (!file) return;

      if (!allowedFileTypes.includes(file.type)) {
        toast.error("Only Image files are allowed.");
        setError("Only Image files are allowed.");
        return;
      }

      if (file.size > maxFileSize) {
        toast.error("File size exceeds the 2MB limit.");
        setError("File size exceeds the 2MB limit.");
        return;
      }
      setError(null);
      formik.setFieldValue("file", file);
    }

    return (
      <Modal show={showUploadModal} onHide={() => setShowUploadModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Profile Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <label htmlFor="file" className="form-label">
                Upload Image (JPG/PNG)
              </label>
              <input
                className="form-control"
                type="file"
                id="file"
                accept=".jpeg,.jpg,.png"
                onChange={handleFileChange}
              />
              {formik.touched.file && formik.errors.file && (
                <div className="text-danger">{formik.errors.file}</div>
              )}

              {error && <div className="text-danger">{error}</div>}
            </div>
            <div className="text-end">
              <button
                className="btn btn-primary btn-sl-sm"
                type="submit"
                disabled={loading || error}
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <>
                    <i className="fa fa-upload me-2" />
                    Upload
                  </>
                )}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  };

  const validationSchema = Yup.object().shape({
    file: Yup.mixed().required("File is required"),
  });

  return (
    <div className="row">
      <div className="profile-container">
        <div className="row">
          <div className="col-12">
            <div className="profile-header">
              <div className="profile-banner">
                <img src={Profile} alt="Profile Banner" />
              </div>

              <div className="progress-container">
                <CircularProgress
                  percentage={Math.ceil(profileInfo?.profile_completion ?? 0)}
                />
              </div>

              <div className="profile-info">
                <div className="profile-avatar">
                  <figure>
                    {isFetching ? (
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <img
                        src={
                          profileInfo?.profile_image_url
                            ? profileInfo?.profile_image_url
                            : "https://via.placeholder.com/150"
                        }
                        alt="&nbsp;"
                      />
                    )}
                  </figure>

                  <div
                    className="edit-icon"
                    onClick={() => setShowUploadModal(true)}
                  >
                    <i className="bi bi-pencil-fill"></i>
                  </div>
                </div>

                <div className="profile-text">
                  <h2>
                    {" "}
                    {profileInfo
                      ? `${capitalize(profileInfo?.first_name)} ${capitalize(
                          profileInfo?.last_name
                        )} (${capitalize(profileInfo?.current_program)})`
                      : "N/A"}
                  </h2>
                  <div className="profile-id">
                    {" "}
                    {profileInfo
                      ? capitalize(profileInfo?.fellow_profile_id)
                      : "N/A"}
                    {isFetching ? (
                      <div
                        className="spinner-border spinner-border-sm ms-4"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UploadModal
        showUploadModal={showUploadModal}
        setShowUploadModal={setShowUploadModal}
        refetch={refetch}
      />
    </div>
  );
};

export default ProfileHeader;
